import React from 'react';

/**
 * Tiny SVG glyph rendered inside a coloured experience dot on the map
 * and on the category chips. Kept as inline stroke-only SVGs so they
 * render crisp at any DPI and inherit `color` from the parent.
 */
export function ExperienceCategoryGlyph({ glyph, size = 12, strokeWidth = 2, color = '#FFFFFF' }) {
  const commonProps = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  switch (glyph) {
    case 'wave':
      return (
        <svg {...commonProps}>
          <path d="M2 12c2-3 4-3 6 0s4 3 6 0 4-3 6 0" />
          <path d="M2 18c2-3 4-3 6 0s4 3 6 0 4-3 6 0" />
        </svg>
      );
    case 'mountain':
      return (
        <svg {...commonProps}>
          <path d="M3 20l6-10 4 6 3-4 5 8H3z" />
          <circle cx="16" cy="7" r="1.4" />
        </svg>
      );
    case 'boot':
      return (
        <svg {...commonProps}>
          <path d="M6 4v10l-2 2v3h14v-3l-3-2V4z" />
          <path d="M10 8v3M14 8v3" />
        </svg>
      );
    case 'camera':
      return (
        <svg {...commonProps}>
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M8 7l2-3h4l2 3" />
          <circle cx="12" cy="13.5" r="3.5" />
        </svg>
      );
    case 'column':
      return (
        <svg {...commonProps}>
          <path d="M4 6h16M4 20h16" />
          <path d="M7 6v14M12 6v14M17 6v14" />
        </svg>
      );
    case 'target':
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="12" cy="12" r="1" fill={color} />
        </svg>
      );
    default:
      return (
        <svg {...commonProps}>
          <circle cx="12" cy="12" r="6" />
        </svg>
      );
  }
}

export default ExperienceCategoryGlyph;
